import { render, staticRenderFns } from "./LLPhoneInput.vue?vue&type=template&id=2aaab90b&scoped=true"
import script from "./LLPhoneInput.vue?vue&type=script&lang=js"
export * from "./LLPhoneInput.vue?vue&type=script&lang=js"
import style0 from "./LLPhoneInput.vue?vue&type=style&index=0&id=2aaab90b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaab90b",
  null
  
)

export default component.exports